import React from 'react';
import {getPublicatieTypeIcon} from 'med-publicatie'
import he from 'he'

const LeeslijstItem = (props) => {


    const {leeslijstItem, localeManager} = props;
    const {zoekresultaat} = leeslijstItem;

    const convertIconsToFA = (iconname) => {
        let rs = iconname;
        switch (iconname) {
            case 'tower':
                rs = 'chess-rook';
                break;
            case 'education':
                rs = 'graduation-cap'
                break;
            case 'duplicate':
                rs = 'book-open'
                break;
            case 'cd-rom':
            case 'cd':
            case 'dvd':
                rs = 'compact-disc'
                break;
            default:
                rs = iconname;
        }
        return `fas fa-${rs}`;
    }

    const onItemClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const win = window.open(`http://lib.arteveldehogeschool.be/mediatheken/live/ws/?dl=search&id=${zoekresultaat.id}&src=${zoekresultaat.bron}` , '_blank');
        win.focus();
    }

    return (

        <li onClick={onItemClick}>
            <div className="ig-row leeslijst-item">
                <div className="ig-row__layout">
                    <div className="ig-type-icon" aria-hidden="true">
                        <i className={convertIconsToFA(getPublicatieTypeIcon(zoekresultaat.publicatietype), '')}></i>
                    </div>
                    <div className="ig-info">
                        <div className="ig-title">
                            {he.decode(zoekresultaat._titel)}
                        </div>
                        <div className="ig-details">
                            <div className="ig-details__item"><b>Bron: </b>{zoekresultaat.bron}</div>
                            <div className="ig-details__item">
                                <b>Publicatietype: </b>{localeManager.getString(zoekresultaat.publicatietype)}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </li>

    )
}


export default LeeslijstItem